import React from 'react'
import { component_tool } from "@/tool";
import { WizClassifySelect } from '../../common'

const { WizModal, WizSurveyAudience,WizTypography,WizRow } = component_tool;
const componentName = "examTemplateGroup";
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    },
  },
  {
    title: "模版组名称",
    name: "title",
    searchItem: {},
    tableItem: {
      width: 300
    },
  },
  {
    title: "可见对象",
    name: "authData",
    type: "hidden",
  },
  {
    name: "examTemplateAuthInfo",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: '考试分类',
    name: 'categoryTypeIds',
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '考试分类',
          tips: '请选择考试分类'
        },
        treeProps: { checkStrictly: true },
        checkable: false
      },
      apiProps: { type: 0 },
      selectProps: {
        placeholder: '请选择考试分类'
      },
    }
  },
  {
    title: '考试分类',
    name: 'categoryType',
    tableItem: {}
  },
  
  
  {
    title: "考试类型",
    name: "examType",
    dataIndex: "examType",
      dict:  [
        { code: 0, codeName: "独立考试" },
        { code: 1, codeName: "课程考试" }
      ],
    searchItem: {
      type: 'select',
    },
    tableItem: {
      width: 100,
    },
  },
  {
    title: "考试时长(分钟)",
    name: "limitMinutes",
    tableItem: {},
  },
  {
    title: "允许重复考试次数",
    name: "count",
    tableItem: {},
  },
  {
    title: "状态",
    name: "status",
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" },
    ],
    searchItem: {
      type: "select",
    },
    tableItem: {},
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ["add", "delete", "export"],
        buttons: [
          {
            key: "export",
            custom: true,
            params: {
              icon: "export",
              children: "导出",
              type: "export",
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "export",
                apiParams: {},
              },
              formatParams: (rows, record, filter) => {
                return { ...filter };
              }
            },
          },
          {
            key: "add",
            custom: true,
            params: {
              icon: "plus",
              children: "新增",
              type: "primary",
            },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname:
                  "/online/examTemplateGroup/examTemplateGroupDetailAdd",
              },
            },
          },
        ],
      },
      rowOperateSort: ["look", "update", "enableOrDisable","templateManagement"],
      rowOperateView: [

        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/online/examTemplateGroup/examTemplateGroupInfo",
            },
          },
        },
        {
          key: "templateManagement",
          custom: true,
          params: { children: "模版管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/online/examTemplateGroup/examTempGroupManage",
            },
          },
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/online/examTemplateGroup/examTemplateGroupDetailUpd",
            },
          },
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: "status",
            dirt: { 1: "禁用", 0: "启用" },
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
            },
            formatParams: (rows, record, filters, callback) => {
              const content =
                "您确定要" +
                (record.status === 1 ? "禁用" : "启用") +
                "该考试模版组吗?";
              WizModal.confirm({
                title: "注意",
                content,
                onOk: () => {
                  callback &&
                    callback({
                      status: record.status === 1 ? 0 : 1,
                      ids: [record.id],
                      ...filters
                    });
                },
                onCancel() { },
              });
              return null;
            },
          },
        },
      ],
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
        // expandedRowRender: (record) => {
        //   return (
        //     <>
        //     <WizRow>
        //       <WizTypography.Paragraph strong>可见对象：</WizTypography.Paragraph>
        //     </WizRow>
        //     <WizSurveyAudience style={{width:1000}} labelWidth={4} data={record['authData']||{}} />
        //     </>
        //   )
        // }
      },
      commonOperate: {
        delete: true,
      },
      showAuth: true
    },
  },
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {},
    },
  },
  delete: {
    path: `${componentName}/del`,
    payload: {
      key: `${componentName}@del`,
      apiParams: {},
    },
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {},
    },
  },
  categoryList: {
    path: "categoryType/categoryList",
    payload: {
      key: `${componentName}@categoryList`,
      apiParams: { type: 0 },
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "categoryList"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
